import { render } from "./InkboardSecondTitle.vue?vue&type=template&id=6b32c38c&scoped=true&ts=true&lang=pug"
import script from "./InkboardSecondTitle.vue?vue&type=script&lang=ts"
export * from "./InkboardSecondTitle.vue?vue&type=script&lang=ts"

import "./InkboardSecondTitle.vue?vue&type=style&index=0&id=6b32c38c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b32c38c"]])

export default __exports__